import React from 'react';
import NoDataImg from '../../assets/images/NOData.svg';

import styled from 'styled-components';
import StyledText from '../../components/StyledComponents/StyledText';
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // height: 100%;
  text-align: center;
  padding: 2rem;
  color: #6c757d;
`;

const Image = styled.img`
  max-width: 200px;
  margin-bottom: 1.5rem;
  margin-top: 3.5rem;

`;
const Dashboard: React.FC = () => {
  return (
    <Container>
      <Image src={NoDataImg} />
      <StyledText fontSize="16px" fontWeight={600} color="#666" className='mb-3'>
        This page is coming soon
      </StyledText>
      <StyledText fontSize="14px" color="#999">
        Page is under development, will be here shortly.
      </StyledText>
    </Container>
  );
};

export default Dashboard;